// Local reimplementation of `@eventbrite/eds-event-card`'s `LoadingCards`
// skeleton (the ONLY export of that package this app uses — the
// "Show more events" loading state in `CollectionEvents`). Emits the SAME
// global class names as the eb-ui original (`.loading-cards__container` /
// `.loading-card` / `.loading-card__item-*` / `.loading-cards--grid`) because
// the app's `src/styles/cc/loading-cards.scss` already keys off them (the
// `.cc-loading-cards` scoping + the responsive grid layout); the base shimmer
// (item background + animation) lives in `src/styles/cc/loading-cards-base.scss`.
import React from 'react';

import classNames from 'classnames';

const LoadingCard = () => (
    <div className="loading-card">
        <div className="loading-card__aside">
            <div className="loading-card__item loading-card__item-0" />
            <div className="loading-card__item loading-card__item-1" />
            <div className="loading-card__item loading-card__item-2" />
            <div className="loading-card__item loading-card__item-3" />
        </div>
        <div className="loading-card__item loading-card__main" />
    </div>
);

export interface LoadingCardsProps {
    cardCount?: number;
    style?: 'grid' | 'list';
}

export const LoadingCards: React.FC<LoadingCardsProps> = ({
    cardCount = 3,
    style = 'grid',
}) => {
    // The container class (extracted so the className expression carries only
    // the full class names — matches the eb-ui original's global names).
    const containerClassName =
        style === 'grid'
            ? 'loading-cards__container loading-cards--grid'
            : 'loading-cards__container loading-cards--list';
    return (
    <section
        className={containerClassName}
        data-testid="loading-cards"
    >
        {Array.from({ length: cardCount }).map((_, index) => (
            <LoadingCard key={`loading-card-${index}`} />
        ))}
    </section>
    );
};

export default LoadingCards;
